import create from 'zustand';

import { ActiveUser } from './use-journey-presence';

type PresenceStore = {
  activeUsers: ActiveUser[];
  actionEditors: Map<string, Set<string>>;
  currentUserId: string | undefined;
  sendActionOpened: (actionId: string) => void;
  sendActionClosed: (actionId: string) => void;
};

const defaultState: PresenceStore = {
  activeUsers: [],
  actionEditors: new Map(),
  currentUserId: undefined,
  sendActionOpened: () => {},
  sendActionClosed: () => {},
};

const usePresenceStore = create<PresenceStore>(() => defaultState);

export const presenceStore = {
  useStore: usePresenceStore,

  setActiveUsers: (activeUsers: ActiveUser[]) => usePresenceStore.setState({ activeUsers }),

  setActionEditors: (actionEditors: Map<string, Set<string>>) =>
    usePresenceStore.setState({ actionEditors }),

  setCurrentUserId: (currentUserId: string | undefined) =>
    usePresenceStore.setState({ currentUserId }),

  setSendFunctions: (
    sendActionOpened: (actionId: string) => void,
    sendActionClosed: (actionId: string) => void
  ) => usePresenceStore.setState({ sendActionOpened, sendActionClosed }),

  reset: () => usePresenceStore.setState(defaultState),
};
